export const phoneNumberMask = (phoneNumber: string): string => {
  return phoneNumber.replace('+', '').replaceAll(' ', '').replace('7', '8');
};
